/**
 * YesFi Explorer config.
 *
 * `EXPLORER_API_URL` 来自 `.env` → `import.meta.env.EXPLORER_API_URL`。
 *
 * 同源反代（默认开启）：
 *   浏览器请求 `/explorer/*` → Vite dev proxy 转发。
 *
 * 直连模式（`SAME_ORIGIN_API=false`）：
 *   浏览器直接请求 `EXPLORER_API_URL/explorer/*`（需后端开 CORS）。
 */

function browserUsesRelativeApi(): boolean {
    if (typeof window === 'undefined') return false
    const raw = import.meta.env?.SAME_ORIGIN_API
    if (raw === undefined || String(raw).trim() === '') return true
    const v = String(raw).trim().toLowerCase()
    if (v === '0' || v === 'false' || v === 'no' || v === 'off') return false
    if (v === '1' || v === 'true' || v === 'yes' || v === 'on') return true
    return true
}

export function getApiBaseUrl(): string {
    if (browserUsesRelativeApi()) return '/explorer'
    const raw = import.meta.env?.EXPLORER_API_URL
    if (!raw || String(raw).trim() === '') return '/explorer'
    return String(raw).trim().replace(/\/$/, '') + '/explorer'
}

export const isProduction = import.meta.env.PROD
export const isDevelopment = import.meta.env.DEV

if (isDevelopment) {
    console.log('[explorer config] apiBaseUrl =', getApiBaseUrl(), '(isDevelopment =', isDevelopment, ')')
}
